export const defaultBusinessContact = { phone: "+1 201-939-7077", email: "info@danarolimo.com" }
export const businessWhatsAppNumber = "+1 (201) 522-0866"
export type BusinessContact = typeof defaultBusinessContact

/** WhatsApp click-to-chat uses the international number without punctuation. */
export function businessContactLinks(contact: BusinessContact) {
  const raw = contact.phone.replace(/\D/g, "")
  const digits = raw.length === 10 ? "1" + raw : raw
  return { whatsapp: `https://wa.me/${businessWhatsAppNumber.replace(/\D/g, "")}`, phone: `tel:+${digits}`, email: `mailto:${encodeURIComponent(contact.email)}` }
}
